export interface PasswordPolicyValidation {
  isValid: boolean;
  error?: string;
}

export function validatePasswordPolicy(
  _password: string
): PasswordPolicyValidation {
  return { isValid: true };
}
